export type PostType = 'NEWS' | 'QUOTE' | 'POLL' | 'PREDICTION' | 'SLIDE';
export const POST_TYPES: PostType[] = ['NEWS', 'QUOTE', 'POLL', 'PREDICTION', 'SLIDE'];
export type PostStatus = 'draft' | 'review' | 'published' | 'unpublished';
export type BroadcastStatus = 'upcoming' | 'live' | 'finished';
export type VoteChannel = 'screen' | 'online';

export const TYPE_LABELS: Record<PostType, string> = {
  NEWS: 'Новость', QUOTE: 'Цитата', POLL: 'Опрос', PREDICTION: 'Прогноз', SLIDE: 'Слайд',
};
export const STATUS_LABELS: Record<BroadcastStatus, string> = {
  upcoming: 'Предстоит', live: 'В эфире', finished: 'Завершена',
};
export const POST_STATUS_LABELS: Record<PostStatus, string> = {
  draft: 'Черновик', review: 'На проверке', published: 'В эфире', unpublished: 'Снято',
};

export interface PublicImage { url: string; width: number; height: number }

export interface NewsContent { title?: string; text: string; photo?: { mediaId: string; caption?: string } }
export interface QuoteContent { quote: string; speaker: string; position?: string; context?: string }
export interface PollContent { question: string; options: { id: string; text: string }[] }
export interface PredictionContent { event: string; deadline: string }
export interface SlideContent { mediaId: string; caption: string; alt: string }

export interface PollResult {
  kind: 'poll';
  total: number;
  options: { id: string; text: string; votes: number; share: number | null }[];
}
export interface PredictionResult {
  kind: 'prediction';
  participants: number;
  average: number | null;
}
export type Result = PollResult | PredictionResult;

/** Публичная проекция записи — без автора, истории и редакционных полей. */
export interface PublicPost {
  id: string;
  broadcastId: string;
  type: PostType;
  version: number;
  isImportant: boolean;
  topic: string | null;
  publishedAt: string;
  correctedAt: string | null;
  permalink: string;
  content: Record<string, unknown>;
  image: (PublicImage & { alt?: string; caption?: string }) | null;
  /** Автор записи — только отображаемое имя (без id и email). */
  author: { name: string } | null;
  /** Динамика мнения 0–100: доля первого варианта опроса или средняя оценка прогноза, по реальным голосам. */
  history?: number[];
  state?: 'open' | 'closed';
  deadline?: string;
  outcome?: 'yes' | 'no' | null;
  result?: Result;
}

export interface ScreenQuestion {
  id: string;
  type: 'POLL' | 'PREDICTION';
  text: string;
  status: 'open' | 'closed';
  participateUrl: string;
  result: Result;
}
export interface ScreenState {
  broadcastId: string;
  version: number;
  question: ScreenQuestion | null;
}

export interface FeedEvent {
  seq: number;
  broadcastId: string;
  kind: 'post.published' | 'post.updated' | 'post.unpublished' | 'post.results' | 'screen.changed';
  postId: string | null;
  version: number;
  post?: PublicPost;
  result?: Result;
  history?: number[];
  state?: 'open' | 'closed';
  screen?: ScreenState;
}
